import CompPrioritiesManager from '@/manager/2.6/CompPrioritiesManager';
import IComp from '@/models/Comp';

export default {
    /**
     * Run priorities on a field using the given comp and field id.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param comp
     * @param fieldId
     */
    async runOnField(comp: IComp, fieldId: number): Promise<void> {
        return await CompPrioritiesManager.runOnField(comp, fieldId);
    },
};
